import { render, staticRenderFns } from "./CeldaSelect.vue?vue&type=template&id=4798b431&scoped=true"
import script from "./CeldaSelect.vue?vue&type=script&lang=js"
export * from "./CeldaSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4798b431",
  null
  
)

export default component.exports